import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, Divider, Theme, withStyles } from '@material-ui/core';
import { TypographyAllProps } from 'globals/types';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsBody from 'ui-elements/typography/FsBody';

export const ContainerBox = withStyles(() => ({
  root: {
    flexWrap: 'wrap',
  },
}))((props: BoxProps) => {
  return <Box display="flex" alignItems="center" {...props} />;
});

interface SectionBoxProps extends BoxProps {
  isLast?: boolean;
}

export const SectionBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    width: '100%',
    marginBottom: spacing(2),
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    [breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
      width: 'auto',
      marginBottom: 0,
    },
    '&.isLast': {
      marginBottom: 0,
    },
  },
}))(({ isLast = false, ...otherProps }: SectionBoxProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));

export const Headline = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    marginBottom: spacing(2),
  },
}))((props: TypographyAllProps) => <FsBody component="h5" {...props} />);

export const VerticalDividerBox = withStyles(({ palette }: Theme) => ({
  root: {
    height: 40,
    width: 1,
    backgroundColor: palette.grey[200],
    marginTop: 10,
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const Caption = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      color: palette.grey[400],
      marginBottom: spacing(2),
      width: '100%',
      [breakpoints.up('lg')]: {
        width: 'auto',
        marginBottom: 0,
        marginRight: spacing(1),
      },
    },
  })
)((props: TypographyAllProps) => <FsCaption component="span" {...props} />);

export const HorizontalLine = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    backgroundColor: palette.grey[200],
    height: 1,
    margin: spacing(2, 0),
  },
}))((props) => <Divider {...props} />);
